export default "__VITE_ASSET__Cj9oR5fq__"